import { css } from "lit";

export const styles = css`
  :host {
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 100%;
    width: 100%;
    max-width: 393px;
    margin: 0 auto;

    padding: var(--sds-size-space-800);
    min-height: 0;
    box-sizing: border-box;
  }

  form {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .logo {
    margin-bottom: var(--sds-size-space-1200);
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .header {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .title-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
  }

  .subtitle {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-03);
    line-height: 1.4;
    color: var(--sds-color-text-default-secondary);
  }

  .social-buttons {
    display: flex;
    gap: 11.57px;
    align-items: center;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .sticky-button-container {
    position: sticky;
    bottom: 0;
    background: var(--sds-color-background-default-default);
    padding: var(--sds-size-space-800);
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
  }

  .submit-button {
    display: grid;
    width: 100%;
    height: fit-content;
    padding-bottom: var(--sds-size-space-800);
  }

  @media (min-width: 1200px) {
    .sticky-button-container {
      position: inherit;
      border-top: none;
      padding-top: 0;
    }

    .submit-button {
      margin-top: var(--sds-size-space-800);
    }
  }

  .form-error {
    color: var(--sds-color-text-danger-default);
    font-size: var(--sds-typography-scale-02);
    margin-top: var(--sds-size-space-300);
    text-align: center;
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-1200);
    margin-top: var(--sds-size-space-800);
  }

  .terms-text {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-01);
    line-height: 1.5;
    color: var(--sds-color-text-default-tertiary);
    max-width: 345px;
  }
`;
